var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSockeyeSalmon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8EEE1;}\n\t.st1{fill:#AA1917;}\n\t.st2{fill:#E6393D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.86,185.11c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.57,150.81,61.17,185.11,103.86,185.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.44,94.68c2.14,2.68,3.29,6.14,3.18,9.57c-0.03,0.92-0.15,1.88,0.17,2.75c0.23,0.63,0.68,1.17,0.9,1.8 c0.69,1.95-0.84,3.9-1.63,5.82c-1.24,3.03-0.83,6.99-3.39,9.02c4.5-1.32,8.72-3.41,12.87-5.57c2.69-1.4,5.49-2.98,6.97-5.62 c2.65-4.72-1.07-7.91-4.3-10.63C58.98,98.25,53.89,95.74,48.44,94.68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.28,115.56c-1.12,0.96-2.66,1.22-4.12,1.44c-0.85,0.13-1.7,0.26-2.54,0.39c1.74,2.87,5.34,4.54,6.25,7.78 c3.57-1.32,7.03-2.92,10.36-4.77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.52,87.02c3.18,0.15,6.24,1.5,8.72,3.49c2.48,1.99,4.42,4.6,5.93,7.4c-0.43-0.81-7.19,3.08-7.88,3.45 c-2.25,1.2-2.76,0.57-4.59-0.89c-2.16-1.71-4.74-1.16-3.56-4.29C99.22,93.25,100.45,90.19,99.52,87.02z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.91,117.25c1.04,1.32,3.07,1.45,4.62,0.81c1.55-0.64,2.77-1.86,4.03-2.97c2.98-2.63,6.74-4.84,10.7-4.47 c0.16-0.6-0.55-1.03-1.14-1.21c-5.43-1.63-11.48,0-16.83-1.89c-5.62-1.99-9.28-7.4-14.44-10.4c-5.84-3.4-13.12-3.38-19.71-1.9 s-12.82,4.26-19.31,6.16c-8.15,2.38-16.72,3.34-25.19,2.81c-1.72-0.11-3.79-0.12-4.74,1.32c-0.38,0.57-0.5,1.27-0.58,1.96 c-0.22,1.86-0.24,3.75-0.06,5.61c0.05,0.48,0.13,1.01,0.5,1.33c0.57,0.49,1.44,0.21,2.16-0.01c3.95-1.17,8.18,0.75,11.39,3.33 s5.85,5.85,9.29,8.11c6.64,4.38,15.17,4.37,23.12,4.02c16.56-0.73,33.43-2.36,48.58-9.07c3.04-1.35,6.41-3.52,6.48-6.84 c-4.29,0.15-8.34,4.42-12.26,2.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSockeyeSalmon);
export default __webpack_public_path__ + "static/media/Sockeye_salmon.af72b13db30e6f40143463bd09176ff6.svg";
export { ForwardRef as ReactComponent };